import React from "react";
import { Icon } from "@mui/material";
import RpSvgIcon from "./icons/RpSvgIcon";

type RpImageTextInlineProps = {
  text?: React.ReactNode;
  image?: string;
  svgIcon?: string;
  textProps?: React.HTMLAttributes<HTMLDivElement>;
  imageProps?: Record<string, unknown>;
  containerProps?: React.HTMLAttributes<HTMLDivElement>;
  alignCenter?: boolean;
};

export default function RpImageTextInline({
  text = "",
  image = "",
  svgIcon = "",
  textProps = {},
  imageProps = {},
  containerProps = {},
  alignCenter = true,
}: RpImageTextInlineProps) {
  return (
    <div
      className={`d-flex ${alignCenter ? "align-items-center" : ""}`}
      {...containerProps}
    >
      {image && (
        <Icon
          component="img"
          src={image}
          width={10}
          height={10}
          className="mr-1"
          fontSize="small"
          {...imageProps}
        />
      )}
      {svgIcon && (
        <Icon
          component={RpSvgIcon as React.ElementType}
          name={svgIcon}
          size={22}
          className="mr-1"
          fontSize="small"
          {...imageProps}
        />
      )}

      <div {...textProps}>{text}</div>
    </div>
  );
}
